export const TrackingParams = {
    YES: 'Yes',
    NO: 'No',
    SEARCH_REFERER: 'Search',
    BROWSE_REFERER: 'Browse',
    HOMEPAGE_REFERER: 'Homepage',
    RECOMMENDATION_REFERER: 'Recommendation',
    EXTERNAL_REFERER: 'External',
    STANDARD_PDP: 'Standard PDP',
    CONTENTFUL_REFERER: 'contentful',
};
